import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Chip,
  Grid,
  Pagination,
  IconButton,
  Paper,
  Divider,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  Skeleton,
  Tooltip,
  Link,
} from "@mui/material";
import {
  Work,
  LocationOn,
  CalendarToday,
  Language,
  FilterList,
  Schedule,
  Business,
  LocationOnOutlined,
  TaskOutlined,
  BusinessCenterOutlined,
  SettingsOutlined,
  FlagOutlined,
  Close,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { CurrentStateContext } from "../../../App";
import employerdefaultimg from "../../../img/employer/empUpdateProfileLogo.png";
import DOMPurify from "dompurify";
import { formatJobDescription } from "../../../utility/data_storage";

const ellipsisStyle = {
  maxWidth: 230,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function CompanyDetails() {
  const [jobList, setJobList] = useState([]);
  const [login, setLogin] = useState(false);
  const [employerDetails, setEmployerDetails] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 6;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [openMoreDetails, setOpenMoreDetails] = useState(false);
  const [jobDescription, setJobDescription] = useState(null);
  const [seekerProfileDetails, setSeekerProfileDetails] = useState();
  const seekerDetails = JSON.parse(localStorage.getItem("seeker"));
  const [jobApplied, setJobApplied] = useState(false);
  const [Applyed, setApplyed] = useState([]);
  const totalPages = (totalCount = jobList.length) => {
    return Math.ceil(totalCount / itemsPerPage);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const { baseUrl, axiosData, customBreakpoints } =
    useContext(CurrentStateContext);
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const moreDetails = (description) => {
    setOpenMoreDetails(true);
    if (description !== "") setJobDescription(description);
  };
  // <!----GET--->
  const getJobList = async () => {
    try {
      const useAxiosData = await axiosData.get(
        `jobs/getbyEmail_id/${location.state.email_id}`
      );
      const { data } = useAxiosData;
      if (useAxiosData.status === 204) {
        setJobList([]);
      } else {
        const activeJobs = data
  .filter((job) => job.job_status === "Active")
  .reverse();
        setJobList(activeJobs);
        setTotalPage(totalPages(data.length));
      }
      setIsLoaded(true);
      // setGetApi(data);
      // getFilterValue(filterName.status, filterName.date, data);
      // setLoading({ ...loading, isLoading: false });
    } catch (err) {
      console.log("Error", err);
    }
  };
  // <!----GET--->
  const getEmployerDetails = async () => {
    try {
      const useAxiosData = await axiosData.get(
        `employers/email/${location.state.email_id}/employer`
      );
      const { data } = useAxiosData;
      if (useAxiosData.status === 204) {
        setEmployerDetails([]);
      } else {
        let bool = false;
        setEmployerDetails(data);
        console.log(data);
      }
      getJobList();
      // setGetApi(data);
      // getFilterValue(filterName.status, filterName.date, data);
      // setLoading({ ...loading, isLoading: false });
    } catch (err) {
      console.log("Error", err);
    }
  };
  const getCurrentPageJob = () => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return jobList.slice(startIndex, endIndex);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getSeekerDetail = async () => {
    try {
      const response = await axiosData.get(`seekers/${seekerDetails.id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data) {
        setSeekerProfileDetails(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    try {
      // getJobList();
      if (seekerDetails?.id) {
        getSeekerDetail();
        ApplyedJob();
      }
      getEmployerDetails();
      // setIsLoaded(true);
    } catch (e) {}
    // handleSort(sortedData);
  }, []);

  const match = (Id) => {
    let value = true;
    Applyed.map((values, index) => {
      if (Id === values.job_id) {
        value = false;
      }
    });

    return value;
  };
  const ApplyedJob = async () => {
    try {
      const response = await axiosData.get(
        `jobapply/getbyseekerid/${seekerDetails.id}`,
        { industry: location.state.industry },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data) {
        setApplyed(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const Apply = async (job) => {
    if (!seekerDetails?.id) {
      setLogin(true);
    } else {
      let res;
      try {
        res = await axiosData.post(
          `jobapply/`,
          {
            job_id: job._id,
            employer_id: job.user_id,
            seeker_id: seekerDetails.id,
            seeker_name: seekerProfileDetails.full_name,
            seeker_email: seekerProfileDetails.email_id,
            seeker_mobile_number: seekerProfileDetails.mobile_number,
            contact_email_id: job.contact_email_id,
            job_title: job.job_title,
            contact_mobile_number: job.phone_number,
            source_from: `Jobpost-${job._id}`,
            fileName: seekerProfileDetails.fileUpload.name,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.status === 201) {
          ApplyedJob();
          setJobApplied(true);
        }
      } catch (error) {
        if (error.response.status === 403) {
          localStorage.removeItem("seeker");
        }
      }
      // alert( JSON.stringify(seekerDetails))
    }
  };
  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, #0a5f7f 0%, #1a4d8f 25%, #663399 50%, #c62368 75%, #ff1b6b 100%)",
        py: 4,
        position: "relative",
        height: "13rem",
      }}
    >
      <Box height={"100%"} sx={{ position: "absolute", width: "100%" }}>
        <Container
          maxWidth="lg"
          sx={{ display: "flex", flexDirection: "column", gap: "25px" }}
        >
          <Paper
            sx={{
              p: 4,
              borderRadius: 2,
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
            }}
          >
            {/* Header Section */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "30px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: customBreakpoints.isMobileDown
                    ? "column-reverse"
                    : "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "15px" }}
                >
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ fontFamily: "Poppins-SemiBold" }}
                  >
                    {isLoaded ? (
                      employerDetails.company_name
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={600}
                        height={40}
                        sx={{ borderRadius: "15px" }}
                      />
                    )}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ maxWidth: 600, mb: 2 }}
                  >
                    {/* Description */}
                  </Typography>
                </Box>
                {/* Logo */}
                <Box
                  sx={{
                    bgcolor: "white",
                    p: 2,
                    borderRadius: 2,
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <img
                    src={
                      employerDetails.logoUpload
                        ? `${baseUrl}employers/logo/email/${employerDetails.email_id}/Admin`
                        : employerdefaultimg
                    }
                    alt="logo"
                    width={"100px"}
                    height={"100px"}
                  />
                </Box>
              </Box>
              <Divider
                sx={{
                  width: "100%",
                  borderColor: "#D2D2D2",
                  borderWidth: "0.5px",
                }}
              />
              {/* Info Chips */}
              <Box sx={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <SettingsOutlined fontSize="small" color="action" />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontFamily: "Poppins-Medium" }}
                  >
                    {isLoaded ? (
                      employerDetails.industry
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={130}
                        height={30}
                        sx={{ borderRadius: "15px" }}
                      />
                    )}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <LocationOnOutlined fontSize="small" color="action" />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontFamily: "Poppins-Medium" }}
                  >
                    {isLoaded ? (
                      employerDetails.district
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={130}
                        height={30}
                        sx={{ borderRadius: "15px" }}
                      />
                    )}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <FlagOutlined fontSize="small" color="action" />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontFamily: "Poppins-Medium" }}
                  >
                    {isLoaded ? (
                      `Founded ${
                        employerDetails.established_year === ""
                          ? "Not Update"
                          : employerDetails.established_year
                      }`
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={130}
                        height={30}
                        sx={{ borderRadius: "15px" }}
                      />
                    )}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Language fontSize="small" color="action" />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontFamily: "Poppins-Medium" }}
                  >
                    {isLoaded ? (
                      employerDetails.company_url ? (
                        <Link
                          href={
                            employerDetails.company_url.startsWith("http")
                              ? employerDetails.company_url
                              : `https://${employerDetails.company_url}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                        >
                          {employerDetails.company_url}
                        </Link>
                      ) : (
                        "Not yet"
                      )
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={130}
                        height={30}
                        sx={{ borderRadius: "15px" }}
                      />
                    )}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Jobs Section */}
          </Paper>
          <Paper
            sx={{
              p: 4,
              borderRadius: 2,
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
            }}
          >
            <Box sx={{ mt: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="600"
                  sx={{ fontFamily: "Poppins-SemiBold" }}
                >
                  {!isLoaded ? (
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={230}
                      height={40}
                      sx={{ borderRadius: "15px" }}
                    />
                  ) : (
                    `Jobs (${jobList.length})`
                  )}
                </Typography>
                <IconButton size="small">
                  <FilterList />
                </IconButton>
              </Box>

              {/* Job Cards Grid */}
              <Grid container spacing={3}>
                {isLoaded ? (
                  jobList.length > 0 ? (
                    jobList.map((job) => (
                      <Grid spacing={2} item xs={12} md={6} lg={4} key={job.id}>
                        <Card
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            "&:hover": { boxShadow: 4 },
                            boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                            borderRadius: "8px",
                            width: "100%",
                          }}
                        >
                          <CardContent
                            sx={{
                              flexGrow: 1,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {/* Job Header */}
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: customBreakpoints.isMobileDown
                                  ? "column-reverse"
                                  : "row",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                mb: 2,
                              }}
                            >
                              <Box>
                                {/* Job Title */}
                                <Typography
                                  variant="h6"
                                  fontWeight="600"
                                  gutterBottom
                                  sx={{
                                    fontFamily: "Poppins-SemiBold",
                                    ...ellipsisStyle,
                                  }}
                                >
                                  {isLoaded ? (
                                    <Tooltip title={job.job_title} arrow>
                                      <span>{job.job_title}</span>
                                    </Tooltip>
                                  ) : (
                                    <Skeleton
                                      animation="wave"
                                      variant="text"
                                      width={230}
                                      height={40}
                                    />
                                  )}
                                </Typography>

                                {/* Company Name */}
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    fontFamily: "Poppins-Medium",
                                    ...ellipsisStyle,
                                  }}
                                >
                                  {isLoaded ? (
                                    <Tooltip
                                      title={employerDetails.company_name}
                                      arrow
                                    >
                                      <span>
                                        {employerDetails.company_name}
                                      </span>
                                    </Tooltip>
                                  ) : (
                                    <Skeleton
                                      animation="wave"
                                      variant="text"
                                      width={230}
                                      height={40}
                                    />
                                  )}
                                </Typography>
                              </Box>

                              {/* Company Logo */}
                              <img
                                src={
                                  employerDetails.logoUpload
                                    ? `${baseUrl}employers/logo/email/${employerDetails.email_id}/Admin`
                                    : employerdefaultimg
                                }
                                alt="logo"
                                width="50"
                                height="50"
                                style={{
                                  objectFit: "contain",
                                  borderRadius: "6px",
                                }}
                              />
                            </Box>

                            {/* Job Details */}
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                mb: 2,
                                flexGrow: 1,
                              }}
                            >
                              {/* Job Type */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <BusinessCenterOutlined
                                  fontSize="small"
                                  color="action"
                                />
                                <Typography
                                  variant="body2"
                                  color="#107334"
                                  sx={{ fontFamily: "Poppins-Medium" }}
                                >
                                  Full Time
                                </Typography>
                              </Box>

                              {/* Experience */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <TaskOutlined fontSize="small" color="action" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    fontFamily: "Poppins-Medium",
                                    ...ellipsisStyle,
                                  }}
                                >
                                  {isLoaded ? (
                                    `${job.experience_min || 0} - ${
                                      job.experience_max || 1
                                    } year experience`
                                  ) : (
                                    <Skeleton
                                      animation="wave"
                                      variant="text"
                                      width={230}
                                      height={40}
                                    />
                                  )}
                                </Typography>
                              </Box>

                              {/* Location */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <LocationOnOutlined
                                  fontSize="small"
                                  color="action"
                                />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    fontFamily: "Poppins-Medium",
                                    ...ellipsisStyle,
                                  }}
                                >
                                  {isLoaded ? (
                                    <Tooltip title={job.job_location} arrow>
                                      <span>{job.job_location}</span>
                                    </Tooltip>
                                  ) : (
                                    <Skeleton
                                      animation="wave"
                                      variant="text"
                                      width={230}
                                      height={40}
                                    />
                                  )}
                                </Typography>
                              </Box>

                              {/* View More */}
                              <Box>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontFamily: "Poppins-Medium",
                                    color: "#005E82",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    moreDetails(job)
                                  }
                                >
                                  View more
                                </Typography>
                              </Box>
                            </Box>

                            {/* Footer */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "auto",
                              }}
                            >
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ fontFamily: "Poppins-Medium" }}
                              >
                                {`Posted ${job.createdDate}`}
                              </Typography>

                              <Button
                                variant="contained"
                                disableElevation
                                disabled={
                                  job.job_status === "InActive" ||
                                  !match(job.job_id)
                                }
                                sx={{
                                  bgcolor: "#005E82",
                                  "&:hover": { bgcolor: "#005070" },
                                  textTransform: "none",
                                  fontFamily: "Poppins-Medium",
                                  padding: "10px",
                                  width: "102px",
                                  height: "44px",
                                  borderRadius: "8px",
                                }}
                                onClick={Apply}
                              >
                                {match(job.job_id) ? "Apply" : "Applyed"}
                              </Button>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight="600"
                        sx={{ fontFamily: "Poppins-SemiBold" }}
                      >
                        No jobs Available
                      </Typography>
                    </Box>
                  )
                ) : null}
              </Grid>

              {/* Pagination */}
              {isLoaded && jobList.length > 0 ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                  <Pagination
                    count={totalPage}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                    sx={{
                      "& .MuiPaginationItem-root": {
                        "&.Mui-selected": {
                          bgcolor: "#006989",
                          "&:hover": {
                            bgcolor: "#005070",
                          },
                        },
                      },
                    }}
                  />
                </Box>
              ) : null}
            </Box>
          </Paper>
        </Container>
      </Box>
      <Dialog
        TransitionComponent={Transition}
        open={login}
        // onClose={() => setLogin(false)}
        sx={{ "& .MuiPaper-root": { color: "white", width: "400px" } }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ backgroundColor: "rgb(16 143 178)", fontWeight: 600 }}
        >
          Login
        </DialogTitle>
        <DialogContent sx={{ mt: 5, mb: 2 }}>
          <DialogContentText sx={{ fontWeight: 600 }}>
            Please login first to apply job !
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="outlined"
            onClick={() => setLogin(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              navigate("/login");
              setLogin(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        TransitionComponent={Transition}
        open={openMoreDetails}
        jobDescription={jobDescription}
        // onClose={() => setOpenMoreDetails(false)}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
            maxWidth: "800px",
            height: "80vh",
          },
        }}
      >
         <DialogContent sx={{ padding: "24px" }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    position: "relative",
                  }}
                >
                  {/* Header */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <img
                      src={
                        jobDescription?.logoUpload
                          ? `${baseUrl}employers/logo/email/${jobDescription.employer_email_id}/Admin`
                          : employerdefaultimg
                      }
                      alt="logo"
                      width={64}
                      height={64}
                      style={{
                        borderRadius: "12px",
                        objectFit: "contain",
                        border: "1px solid #eee",
                        padding: "6px",
                        background: "#fafafa",
                      }}
                    />
      
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Poppins-SemiBold",
                          fontSize: "20px",
                          color: "#111",
                        }}
                      >
                        {jobDescription?.job_title || "Job Title"}
                      </Typography>
      
                      <Typography sx={{ fontSize: "14px", color: "#666" }}>
                        {jobDescription?.company_name || "Company Name"} •{" "}
                        {jobDescription?.job_location || "Location"}
                      </Typography>
                    </Box>
                  </Box>
      
                  {/* Close Button */}
                  <IconButton
                    aria-label="close"
                    onClick={() => setOpenMoreDetails(false)}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                      color: "#000",
                    }}
                  >
                    <Close sx={{ fontSize: "26px" }} />
                  </IconButton>
      {/* Key Skills */}
      {jobDescription?.key_skills && (
        <Box
          sx={{
            mt: 1,
            borderRadius: "12px",
            padding: "14px 16px",
            border: "1px solid #E6EEFF",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Poppins-SemiBold",
              fontSize: "15px",
              mb: 1,
              color: "#111",
            }}
          >
            Key Skills
          </Typography>
      
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {(Array.isArray(jobDescription.key_skills)
              ? jobDescription.key_skills
              : jobDescription.key_skills.split(",")
            ).map((skill, index) => (
              <Chip
                key={index}
                label={skill.trim()}
                sx={{
                  fontFamily: "Poppins-Medium",
                  background: "#E8F0FE",
                  color: "#1A4ED8",
                  fontSize: "13px",
                  height: "28px",
                }}
              />
            ))}
          </Box>
        </Box>
      )}
                  {/* Meta Info */}
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      mt: 1,
                    }}
                  >
                    <Chip
                      label={`Experience: ${jobDescription?.experience_min==""?0:jobDescription?.experience_min} - ${jobDescription?.experience_max===""?1:jobDescription?.experience_max}`}
                    />
                    <Chip
                      label={`Salary: ₹${jobDescription?.salary_range_min} - ₹${jobDescription?.salary_range_max} / ${jobDescription?.salary_type}`}
                    />
                    <Chip
                      label={`Openings: ${jobDescription?.number_of_positions}`}
                    />
                    <Chip label={jobDescription?.job_status} color="success" />
                  </Box>
      
                  {/* Description */}
                  <Box
                    sx={{
                      mt: 2,
                      background: "#FAFAFA",
                      borderRadius: "12px",
                      padding: "16px 18px",
                      border: "1px solid #EAEAEA",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins-SemiBold",
                        fontSize: "16px",
                        mb: 1,
                        color: "#111",
                      }}
                    >
                      Job Description
                    </Typography>
      
                    {jobDescription?.job_description ? (
                      <DialogContentText
                        sx={{
                          fontFamily: "Poppins-Medium",
                          color: "#555",
                          lineHeight: 1.8,
      
                          "& p": { mb: "10px" },
                          "& strong": { color: "#111" },
                          "& ul": { pl: "20px" },
                          "& li": { mb: "8px" },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize( formatJobDescription(jobDescription.job_description)),
                        }}
                      />
                    ) : (
                      <Typography color="text.secondary">
                        No description for this job
                      </Typography>
                    )}
                  </Box>
      
                  {/* Contact Info */}
                  <Box
                    sx={{
                      mt: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                      fontSize: "14px",
                      color: "#666",
                    }}
                  >
                    <Typography>📧 {jobDescription?.contact_email_id}</Typography>
                    <Typography>📞 {jobDescription?.phone_number}</Typography>
                  </Box>
                </Box>
              </DialogContent>

        {/* <DialogActions>
          <Button
            sx={{ mr: 2, mb: 1 }}
            variant="outlined"
            onClick={() => setOpenMoreDetails(false)}
          >
            Ok
          </Button>
        </DialogActions> */}
      </Dialog>
      <Dialog
        TransitionComponent={Transition}
        open={jobApplied}
        sx={{ "& .MuiPaper-root": { width: "300px" } }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ color: "white", fontWeight: 600 }}
        >
          Job Apply
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          <DialogContentText sx={{ fontWeight: 600 }}>
            Your job applied successfully!.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => setJobApplied(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
